import { Link } from "react-router-dom";
import { Logo } from "@/components/logo";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function TopNav() {
  return (
    <header className="sticky top-0 z-50 h-16 w-full border-b border-zinc-200/70 bg-zinc-50/80 backdrop-blur-md">
      <div className="mx-auto flex h-full max-w-5xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-zinc-400/60"
        >
          <Logo showWordmark />
        </Link>
        <nav className="flex items-center gap-3">
          <a
            href="/#how-it-works"
            className={cn(
              buttonVariants({ variant: "ghost", size: "sm" }),
              "text-zinc-600 hover:text-zinc-900"
            )}
          >
            How it works
          </a>
          <Link
            to="/login"
            className={cn(
              buttonVariants({ size: "sm" }),
              "bg-zinc-900 text-zinc-50 hover:bg-zinc-800"
            )}
          >
            Get started
          </Link>
        </nav>
      </div>
    </header>
  );
}
